import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Cloudinary } from "@cloudinary/url-gen";

/****************ESTILOS*****************/

// El botón azul medio: con la letra en el azul oscuro (en blanco daba 2.8:1), y al pasar el mouse se aclara (oscurecerlo la dejaba en
// 2.7:1), como los botones azules de MUI
export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  backgroundColor: theme.palette.secondary.main,
  "&:hover": {
    backgroundColor: theme.palette.secondary.light,
  },
}));

/****************FUNCIONES*****************/

export const obtenerUbicacion = () => {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(objPosition => {
        let lon = objPosition.coords.longitude;
        let lat = objPosition.coords.latitude;
        let accuracy = objPosition.coords.accuracy;

        resolve({ lon, lat, accuracy });
      }, objPositionError => {
        switch (objPositionError.code) {
          case objPositionError.PERMISSION_DENIED:
            console.log("No se ha permitido el acceso a la posición del usuario.")
            break;
          case objPositionError.POSITION_UNAVAILABLE:
            console.log("No se ha podido acceder a la información de su posición.");
            break;
          case objPositionError.TIMEOUT:
            console.log("El servicio ha tardado demasiado tiempo en responder.");
            break;
          default:
            console.log("Error desconocido.");
        }
      }, {
        maximumAge: 75000,
        timeout: 15000
      });
    })
  } else {
    console.log("Su navegador no soporta la API de geolocalización.");
  }
}

// Las coordenadas de una dirección según Google ({ lat, lng }), con el buscador de Google Maps que carga public/index.html: funciona con
// la llave limitada a los dominios de la web (la API REST de Geocoding la rechaza). Siempre contesta: null si no la encuentra, si falla,
// si la página no tiene el script de Maps o si tarda más de 5 segundos, para que quien espera pueda quitar el círculo de carga
export const getLatLong = (nombreDireccion, esperaMaxima = 5000) => {
  return new Promise((resolve) => {
    const Geocoder = window.google?.maps?.Geocoder;
    if (!Geocoder || !nombreDireccion) return resolve(null);
    const rendirse = setTimeout(() => resolve(null), esperaMaxima);
    const contestar = (punto) => {
      clearTimeout(rendirse);
      resolve(punto);
    };
    try {
      const respuesta = new Geocoder().geocode({ address: nombreDireccion }, (results, status) => {
        if (status !== 'OK' && status !== 'ZERO_RESULTS') console.error('Google Maps no ubicó la dirección:', status);
        contestar(status === 'OK' ? puntoGuardado(puntoDeGoogle(results?.[0]?.geometry?.location)) : null);
      });
      // Las versiones nuevas de Maps además devuelven una promesa que se rechaza si no la encuentra: ya se contestó arriba
      respuesta?.catch?.(() => {});
    } catch (error) {
      console.error(error);
      contestar(null);
    }
  })
}

// Las coordenadas guardadas de una ubicación (GeoJSON [lng, lat], como las guarda el servidor) como { lat, lng }, o null si no tiene
// o no son válidas
export const puntoGuardado = (location) => {
  const c = location?.coordinates;
  if (!Array.isArray(c) || c.length !== 2 || !c.every(Number.isFinite)) return null;
  const [lng, lat] = c;
  return Math.abs(lng) <= 180 && Math.abs(lat) <= 90 ? { lat, lng } : null;
}

// Al revés: el punto que da Google Maps al elegir una dirección (geometry.location, con lat() y lng()) como lo guarda el servidor
// (GeoJSON [lng, lat]), o null si no trae uno válido
export const puntoDeGoogle = (location) => {
  const lat = typeof location?.lat === 'function' ? location.lat() : location?.lat;
  const lng = typeof location?.lng === 'function' ? location.lng() : location?.lng;
  return puntoGuardado({ coordinates: [lng, lat] }) ? { type: 'Point', coordinates: [lng, lat] } : null;
}

export const calcCrow = (lat1, lon1, lat2, lon2) => {
  let R = 6371; // km
  let dLat = toRad(lat2 - lat1);
  let dLon = toRad(lon2 - lon1);
  let lat1R = toRad(lat1);
  let lat2R = toRad(lat2);

  let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1R) * Math.cos(lat2R);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d;
}

// Converts numeric degrees to radians
const toRad = (Value) => {
  return Value * Math.PI / 180;
}

export const cld = new Cloudinary({
  cloud: {
    cloudName: 'daprno5qo',
    invalidate: false,
  }
});

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const areAllValuesEmpty = obj => {
  if (!obj || typeof obj !== 'object') return false;
  const values = Object.values(obj);
  if (values.length === 0) return true;

  return values.every(value => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && areAllValuesEmpty(value)) return true; // Verificación recursiva
    return false;
  });
}

// "3 Horas" si el servicio tiene duración; '' si no. Nunca se inventa una duración por defecto:
// quien llama decide no mostrar nada cuando el resultado es ''.
export const textoDuracion = (duracionEstimada, unidadDuracion) => {
  const duracion = String(duracionEstimada ?? '').trim();
  return duracion ? `${duracion} ${unidadDuracion || 'horas'}` : '';
};

/****************IMAGENES*****************/

export const urlImg = "https://res.cloudinary.com/daprno5qo/image/upload";